"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("./icons");
var Text_1 = require("../Text");
var styles_1 = __importDefault(require("./styles"));
exports.Checkbox = (0, react_1.memo)((0, react_1.forwardRef)(function (_a, ref) {
    var label = _a.label, id = _a.id, indeterminate = _a.indeterminate, labelStyles = _a.labelStyles, checkboxStyles = _a.checkboxStyles, rest = __rest(_a, ["label", "id", "indeterminate", "labelStyles", "checkboxStyles"]);
    var defaultRef = react_1.default.useRef();
    var resolvedRef = ref || defaultRef;
    var classes = (0, styles_1.default)();
    var icons = (0, react_1.useMemo)(function () { return ({
        checked: indeterminate === true ? (0, jsx_runtime_1.jsx)(icons_1.Indeterminate, {}) : (0, jsx_runtime_1.jsx)(icons_1.Checked, {}),
        unchecked: (0, jsx_runtime_1.jsx)(icons_1.Unchecked, {}),
    }); }, [indeterminate]);
    var disabledIcons = (0, react_1.useMemo)(function () { return ({
        checked: indeterminate === true ? (0, jsx_runtime_1.jsx)(icons_1.IndeterminateDisabled, {}) : (0, jsx_runtime_1.jsx)(icons_1.CheckedDisabled, {}),
        unchecked: (0, jsx_runtime_1.jsx)(icons_1.UncheckedDisabled, {}),
    }); }, [indeterminate]);
    // NOTE: you can't have indeterminate type AND pass a custom icon... for some reason
    var CheckboxPartial = react_1.default.memo(function (_a) {
        var more = __rest(_a, []);
        return more.disabled ? ((0, jsx_runtime_1.jsx)(core_1.Checkbox, __assign({ icon: disabledIcons.unchecked, checkedIcon: disabledIcons.checked }, more))) : ((0, jsx_runtime_1.jsx)(core_1.Checkbox, __assign({ icon: icons.unchecked, checkedIcon: icons.checked }, more)));
    });
    return ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ size: "medium", lineHeight: 1.55 }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { className: classes.label, label: label, htmlFor: id, control: (0, jsx_runtime_1.jsx)(CheckboxPartial, __assign({ id: id }, rest, { style: checkboxStyles })), ref: resolvedRef, style: labelStyles }) })));
}));
exports.Checkbox.displayName = 'Checkbox';
